import { pixelRatio2d } from '@/editor/math/const';
import { IPoint2d } from '@/editor/math/IPoint2d';
import { adsorbWallLineColor, ENTITY_RENDER_ORDER } from '@/editor/constant/entity';
import BaseModel2d from './BaseModel2d';
import { globalStores } from '@/editor/stores';
import { LineMaterial, LineSegments2, LineSegmentsGeometry } from 'three/examples/jsm/Addons.js';
import { ArcSeg2d } from '@/editor/math/arcSeg2d';
import { isArc } from '@/editor/utils/arc';

type TExtraSubLine = { start: IPoint2d; end: IPoint2d; center?: IPoint2d; clockwise?: boolean };

const dashLineMaterial = new LineMaterial({
  color: adsorbWallLineColor,
  userData: { shared: true },
  linewidth: 1.25,
  dashScale: 10, // 缩小10倍
  dashSize: 0.5, // 500mm线段
  gapSize: 0.5, // 500mm间隔
  dashed: true,
  depthTest: false
});

class SublineModel extends BaseModel2d {
  constructor() {
    super();

    this.setDisplayOrder(ENTITY_RENDER_ORDER.subline);
    globalStores.editorStateStore.sceneInfo.scene2d.scene.add(this._modelGroup);
  }

  private createDashLineModel(lines: TExtraSubLine[]) {
    const dashLineGmt = new LineSegmentsGeometry();
    const positions: number[] = [];
    lines.forEach((line) => {
      if (!isArc(line)) {
        positions.push(
          line.start.x / pixelRatio2d,
          line.start.y / pixelRatio2d,
          0,
          line.end.x / pixelRatio2d,
          line.end.y / pixelRatio2d,
          0
        );
      } else {
        const arc = new ArcSeg2d({ start: line.start, end: line.end, center: line.center, clockwise: line.clockwise });
        const points = arc.getPoints();
        for (let i = 0; i < points.length - 1; i++) {
          const curPoint = points[i];
          const nextPoint = points[(i + 1) % points.length];
          positions.push(
            curPoint.x / pixelRatio2d,
            curPoint.y / pixelRatio2d,
            0,
            nextPoint.x / pixelRatio2d,
            nextPoint.y / pixelRatio2d,
            0
          );
        }
      }
    });
    dashLineGmt.setPositions(positions);

    const dashLine = new LineSegments2(dashLineGmt, dashLineMaterial);
    dashLine.computeLineDistances();
    dashLine.renderOrder = ENTITY_RENDER_ORDER.subline;
    this._modelGroup.add(dashLine);
  }

  update(lines: TExtraSubLine[]) {
    this._modelGroup.clear();
    this.createDashLineModel(lines);
  }
}

export default SublineModel;
